import { render, staticRenderFns } from "./KInplay.vue?vue&type=template&id=ff4f316e"
import script from "./KInplay.vue?vue&type=script&lang=js"
export * from "./KInplay.vue?vue&type=script&lang=js"
import style0 from "./KInplay.vue?vue&type=style&index=0&id=ff4f316e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports